import peopleShowController from "./people-show-controller";

export default class extends peopleShowController {}



// WEBPACK FOOTER //
// ./app/components/people/assets/javascript/people-access-details-controller.js